import * as TerrassorConst from '../../terrassor_const.js'
/* @ngInject */
export class ApiConst {
  /* @ngInject */
  constructor(TerrassorDB, $q) {
    // Injection des dépendances TerrassorDB et $q
    // on les enregistre sur 'this' afin de les reutiliser plus tard.
    this.TerrassorDB = TerrassorDB;
    this.$q = $q;
    this.allJsonTables = this.TerrassorDB.loveField.allJsonData.tables;

  }

/*
* une seule ligne dans table (id == 1)
*/
  getConstantesSimulateur() {
    return this.TerrassorDB.getRowInTableImmediate(1, 'const_constantes')
  }
/*
*   2017.12.04. données prises dans les tables constantes (liées à lfS)
* retourne un array (pas une Promise)
*/
  getAllSolsImmediate() {
    return (this.TerrassorDB.getJsonTable("const_sols"))
  }

  /*
*   2017.01.23. données prises dans les tables constantes (liées à lfS)
*/
  getAllCubatureTypes() {
    return this.$q.resolve(
      this.TerrassorDB.getJsonTable("const_cubaturestypes")
    );
   
  }

/*
*   2017.02.18. données prises dans les tables constantes (liées à lfS)
* retourne un array (pas une Promise)
*/
  getAllGodetsImmediate() {
    return (this.TerrassorDB.getJsonTable("const_godets"))
  }

  getGodetName(id) {
    if(!id)
      return ''
    var godet = this.TerrassorDB.getRowInTableImmediate(id, 'const_godets') 
    return godet.nom
  }

    getOptionName(id) {
    if(!id)
      return ''
    var option = this.TerrassorDB.getRowInTableImmediate(id, 'const_options')
    if(option.code == 'GODE' || option.code == 'SANS' ) 
      return ''
    return option.nom
  }



  getHumiditeName(id) {
    var t = this.TerrassorDB.getJsonTable("const_humidites");
    var row = t[id - 1];
    return row.nom;
  }

  triParCode(a,b) {
    if (a.code >= b.code) return(true);
      return(false);
  }
  triParOrdre(a,b) {
    if (a.ordre >= b.ordre) return(true);
        return(false);
  }

  getAllEnginsByFamilleID(const_famillesengins_id) {
    var t = this.TerrassorDB.getJsonTable("const_engins");
    var engins = t.filter(item=> item.const_famillesengins_id == const_famillesengins_id);

      // BC 2018/09 - on peut trier par ordre si c'est demandé sur la famille !
    var trouveOrdre0 = engins.find(function(element) {
        return ((typeof(element.ordre) == 'undefined') || element.ordre == 0);
    });

    if (trouveOrdre0) {
        engins.sort(this.triParCode);
    }
    else {
        engins.sort(this.triParOrdre);
      }

    //return  this.$q.resolve(Promise.resolve(engins));
    return  engins;
       
  }

  /*
* RA 2017.01.23; Données prises dans le "cache" json des tables
*/
  getAllFamillesEngins(params) {
    return this.$q.resolve(
      this.TerrassorDB.getJsonTable("const_famillesengins")
    );
    /*return this.TerrassorDB.getDbConnection()
    .then(db => {
      var const_famillesengins = this.TerrassorDB.tables.const_famillesengins

      var query = db
        .select()
        .from(const_famillesengins)
        .exec()

      return this.$q.resolve(query)
    })*/
  }

  getFamilleenginById(familleengin_id) {
    return this.TerrassorDB.getDbConnection().then(db => {
      let { const_famillesengins } = this.TerrassorDB.tables;

      let query = db
        .select()
        .from(const_famillesengins)
        .where(const_famillesengins.id.eq(familleengin_id))
        .exec();

      return this.$q.resolve(query).then(resultsArray => resultsArray.pop());
    });
  }

  getEnginById(engin_id) {
    return this.TerrassorDB.getDbConnection().then(db => {
      let { const_engins } = this.TerrassorDB.tables;

      let query = db
        .select()
        .from(const_engins)
        .where(const_engins.id.eq(engin_id))
        .exec();

      return this.$q.resolve(query).then(resultsArray => resultsArray.pop());
    });
  }

/*
*   Description complète de l'engin (depuis les tables json - Constantes -  importées)
*/
  getAllForEngin(engin_id) {
    var t = this.TerrassorDB.getJsonTable("const_enginsplus");
    var engins = t.filter(item=> item.Id == engin_id); // !! nomenclature des champs dans MySQL (Id <> id)
    var theEngin = engins[0];

    return this.$q.resolve(theEngin);
  }

/*
* caractéristiques "parametres d'un engin"
*/
  getParametresForEngin(familleengin_id, engin_id) {

    return this.getAllForEngin(engin_id)
}


/*
* RA. 18.02.17 ajout ordre
*/
  getAllPhases() {
    return this.TerrassorDB.getDbConnection().then(db => {
      let { const_phases } = this.TerrassorDB.tables;

      let query = db.select().from(const_phases).orderBy(const_phases.ordre).exec()

      return this.$q.resolve(query);
    });
  }

  getPhasesForFamilleengin(familleengin_id) {
    return this.TerrassorDB
      .getDbConnection()
      .then(db => {
        let {
          const_famillesengins_const_options_const_phases,
          const_phases,
          const_options
        } = this.TerrassorDB.tables;

        let query = db
          .select()
          .from(const_famillesengins_const_options_const_phases)
          .innerJoin(
            const_options,
            const_options.id.eq(
              const_famillesengins_const_options_const_phases.const_options_id
            )
          )
          .innerJoin(
            const_phases,
            const_phases.id.eq(
              const_famillesengins_const_options_const_phases.const_phases_id
            )
          )
          .where(
            const_famillesengins_const_options_const_phases.const_famillesengins_id.eq(
              familleengin_id
            )
          )
          .exec();

        return this.$q.resolve(query);
      })
      .then(result => {
        // Je n'ai pas reussi à faire fonctionner le .groupBy() donc j'ai groupé les options par phase
        let options = {};
        let phases = {};
        result.forEach(item => {
          options[item.const_phases.code] = [];
        });

        result.forEach(item => {
          options[item.const_phases.code].push(item.const_options);
          phases[item.const_phases.code] = item.const_phases;
        });

        const phasesList = Object
          .keys(phases)
          .map(phaseCode => {
            return { const_phases: phases[phaseCode] };
          })
          .sort(
            (a, b) =>
              parseInt(a.const_phases.ordre) - parseInt(b.const_phases.ordre)
          );

        return { phases: phasesList, options: options };
      });
  }

  /*
  *
  */
  getAllInstallations() {
    //return this.TerrassorDB.readAllFromTable('const_installations')
    return this.TerrassorDB.getDbConnection().then(db => {
      let { const_installations } = this.TerrassorDB.tables;

      let query = db.select().from(const_installations).orderBy(const_installations.libelle_court).exec()

      return this.$q.resolve(query);
    });
  }

  // ********
}



// WEBPACK FOOTER //
// ./src/client/common/api/ApiConst.js